import { SwedishKronaSign } from "../../../../assets/images";

type AppProps = {
  tableHeader: any;
  data: any;
  changeYear: boolean;
  history: any;
  client_code: number | null;
  showGraph: boolean;
  currencySign: string | undefined;
};

const Yearly = ({
  tableHeader,
  data,
  changeYear,
  history,
  client_code,
  showGraph,
  currencySign
}: AppProps) => {


  const handleSetIcon = (px: number) => {
    // return<i style={{ fontSize: `${px}px` }}>{currencySign}</i>
    switch (client_code) {
      case 320:
      case 371:
      case 906:
      case 382:
      case 881:
      case 909:
      case 331:
      case 3871:
      case 3872:
        return (
          <i style={{ fontSize: `${px}px` }} className="las la-dollar-sign"></i>
        );
      case 907:
      case 880:
      case 184:
      case 3197:
        return (
          <i style={{ fontSize: `${px}px` }} className="las la-pound-sign"></i>
        );
        case 302:
          return <img src={SwedishKronaSign} className="swedish-icon"/>
      default:
        return (
          <i style={{ fontSize: `${px}px` }} className="las la-rupee-sign"></i>
        );
    }
  };
  const renderTableData = () => {
    const finalTableData =
      data?.length > 0 &&
      data?.map((dataItem: any, index: number) => {
        return (
          <>
            <tr
              style={{ background: index === data.length - 1 ? "#ccccd1" : "" }}
            >
              <>
                <td
                  style={{
                    minWidth: "150px",
                    maxWidth: "230px",
                    whiteSpace: "nowrap",
                    textAlign: "left",
                    height: "60px",
                  }}
                >
                  {changeYear
                    ? dataItem?.current_yearly
                    : dataItem?.prev_yearly}
                  <br></br>
                  {showGraph && (
                    <span style={{ color: "#676464", fontSize: "11px" }}>
                      {changeYear && dataItem?.prev_yearly}
                      {!changeYear && dataItem?.current_yearly}
                    </span>
                  )}
                </td>
                <td
                  style={{
                    minWidth: "150px",
                    maxWidth: "230px",
                    whiteSpace: "nowrap",
                    textAlign: "left",
                    height: "60px",
                  }}
                >
                  {changeYear
                    ? dataItem?.current_year_percentage == null
                      ? 0
                      : dataItem?.current_year_percentage
                    : dataItem?.prev_year_percentage == null
                      ? 0
                      : dataItem?.prev_year_percentage}{" "}
                  %<br></br>
                  {showGraph && (
                    <span style={{ color: "#676464", fontSize: "11px" }}>
                      {changeYear
                        ? dataItem?.prev_year_percentage == null
                          ? 0
                          : dataItem?.prev_year_percentage
                        : dataItem?.current_year_percentage == null
                          ? 0
                          : dataItem?.current_year_percentage}
                      {" "}%
                    </span>
                  )}
                </td>
              </>
            </tr>
          </>
        );
      });

    return finalTableData;
  };

  return <>{renderTableData()}</>;
};

export default Yearly;
